import errorTracker from "@evercam/shared/plugins/errorTracker"
import { defineNuxtPlugin } from "#app"

export default defineNuxtPlugin(errorTracker())
